import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { MegaMenuModule } from 'primeng/megamenu';
import { ChartModule } from 'primeng/chart';
import { SelectModule } from 'primeng/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ImpactReportComponent } from './components/impact-report/impact-report.component';
import { CustomPieChartComponent } from './components/graphs/custom-pie-chart/custom-pie-chart.component';
import { CarbonIntensityComponent } from './components/carbon-intensity/carbon-intensity.component';
import { IntensityGaugeComponent } from './components/graphs/intensity-gauge/intensity-gauge.component';
import { AnnualBudgetComponent } from './components/annual-budget/annual-budget.component';
import { CustomProgressBarComponent } from './components/graphs/custom-progress-bar/custom-progress-bar.component';
import { ImpactEquivalentCardComponent } from './components/impact-equivalent-card/impact-equivalent-card.component';
import { CardModule } from 'primeng/card';
import { Breadcrumb } from 'primeng/breadcrumb';
import { RouterModule } from '@angular/router';
import { PageHeaderComponent } from '../shared/components/page-header/page-header.component';
import { PopoverModule } from 'primeng/popover';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ExportPdfComponent } from './components/export-pdf/export-pdf.component';
import { CarbonEquivalenceComponent } from './components/carbon-equivalence/carbon-equivalence.component';
import { LegendGraphComponent } from './components/graphs/legend-graph/legend-graph.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import {
  LucideAngularModule,
  Car,
  Refrigerator,
  Package,
  Shirt,
  Coffee,
  Pizza,
  Smartphone,
  CakeSlice,
  Globe,
  House,
  Apple,
  Gauge,
  Percent,
  List,
  User,
  CableCar,
  Leaf,
} from 'lucide-angular';
import { ImpactPerDayGraphComponent } from './components/graphs/impact-per-day-graph/impact-per-day-graph.component';

@NgModule({
  declarations: [
    ImpactReportComponent,
    CustomPieChartComponent,
    CarbonIntensityComponent,
    CarbonEquivalenceComponent,

    AnnualBudgetComponent,
    CustomProgressBarComponent,
    ImpactEquivalentCardComponent,
    ExportPdfComponent,
    LegendGraphComponent,
    ImpactPerDayGraphComponent,
  ],
  imports: [
    LucideAngularModule.pick({
      CakeSlice,
      Car,
      Refrigerator,
      Package,
      Shirt,
      Coffee,
      Pizza,
      Smartphone,
      Globe,
      House,
      Apple,
      Gauge,
      Percent,
      List,
      User,
      CableCar,
      Leaf,
    }),
    SelectButtonModule,
    ToggleSwitchModule,
    DialogModule,
    ProgressSpinnerModule,
    PopoverModule,
    CommonModule,
    MenubarModule,
    MegaMenuModule,
    SelectModule,
    ChartModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    ButtonModule,
    ToastModule,
    TooltipModule,
    CardModule,
    Breadcrumb,
    RouterModule,
    PageHeaderComponent,
    CheckboxModule,
    IntensityGaugeComponent,
  ],
  providers: [],
})
export class ImpactModule {}
